(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["colani-watch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('colani-watch')) {
  customElements.define('colani-watch', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.radios = [...this.querySelectorAll('input[type="radio"][name="id"]')];
      this.accessoryMode = this.dataset.accessory === 'true';
      this.dialog = this.querySelector('dialog');
      this.addEventListener('change', event => {
        if (this.radios.includes(event.target)) this.selectVariant(event.target, true);
      });
      this.querySelector('[data-zoom]').addEventListener('click', () => {
        const main = this.querySelector('.cw-main-image');
        if (!main.getAttribute('src')) return;
        const zoom = this.querySelector('[data-zoom-image]');
        zoom.src = main.src;
        zoom.alt = main.alt;
        this.querySelector('[data-zoom-caption]').textContent = main.alt;
        this.dialog.showModal();
      });
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.querySelector('form').addEventListener('submit', event => {
        const selected = this.radios.find(radio => radio.checked);
        if (!selected || selected.dataset.available !== 'true') event.preventDefault();
      });
      this.restore = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const radio = this.radios.find(r => r.value === id) || this.radios.find(r => r.defaultChecked);
        if (radio) { radio.checked = true; this.selectVariant(radio, false); }
      };
      window.addEventListener('popstate', this.restore);
      this.restore();
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.restore); }
    selectVariant(radio, updateUrl) {
      const data = radio.dataset;
      this.querySelectorAll('[data-color]').forEach(el => { el.textContent = data.title; });
      this.querySelector('[data-price]').textContent = data.price;
      const sku = this.querySelector('[data-sku]');
      if (sku) sku.textContent = data.sku || '–';
      const compare = this.querySelector('[data-compare]');
      compare.textContent = data.compare;
      compare.hidden = !data.compare;
      if (!this.accessoryMode) {
        const main = this.querySelector('.cw-main-image');
        const zoom = this.querySelector('[data-zoom]');
        main.removeAttribute('srcset');
        main.hidden = !data.image;
        zoom.hidden = !data.image;
        this.querySelector('[data-missing]').hidden = !!data.image;
        this.querySelector('[data-missing-title]').textContent = data.title;
        if (data.image) { main.src = data.image; main.alt = data.alt; } else { main.removeAttribute('src'); main.alt = ''; }
      }
      const available = data.available === 'true';
      const buy = this.querySelector('[data-buy]');
      const stock = this.querySelector('[data-stock]');
      buy.disabled = !available;
      buy.textContent = available ? buy.dataset.yes : buy.dataset.no;
      stock.textContent = available ? stock.dataset.yes : stock.dataset.no;
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', radio.value); history.replaceState(null, '', url); }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
